import { render, staticRenderFns } from "./billLadingManageDetails.vue?vue&type=template&id=63ff83de&scoped=true"
import script from "./billLadingManageDetails.vue?vue&type=script&lang=js"
export * from "./billLadingManageDetails.vue?vue&type=script&lang=js"
import style0 from "./billLadingManageDetails.vue?vue&type=style&index=0&id=63ff83de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff83de",
  null
  
)

export default component.exports